import { useState, useEffect } from 'react';

interface UseWindowVisibilityReturn {
    isWindowVisible: boolean;
    isTabActive: boolean;
}

export const useWindowVisibility = (): UseWindowVisibilityReturn => {
    const [isWindowVisible, setIsWindowVisible] = useState(true);
    const [isTabActive, setIsTabActive] = useState(true);

    useEffect(() => {
        // 检测页面可见性
        const handleVisibilityChange = () => {
            const isVisible = !document.hidden;
            setIsTabActive(isVisible);
            setIsWindowVisible(isVisible);
            // console.log('客服端页面可见性变化:', isVisible ? '可见' : '隐藏');
        };

        // 检测窗口焦点
        const handleFocus = () => {
            setIsWindowVisible(true);
            // console.log('客服端窗口获得焦点');
        };

        const handleBlur = () => {
            setIsWindowVisible(false);
            // console.log('客服端窗口失去焦点');
        };

        // 检测鼠标进入/离开页面
        const handleMouseEnter = () => {
            if (isTabActive) {
                setIsWindowVisible(true);
            }
        };

        const handleMouseLeave = () => {
            setIsWindowVisible(false);
        };

        // 添加事件监听器
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);
        document.addEventListener('mouseenter', handleMouseEnter);
        document.addEventListener('mouseleave', handleMouseLeave);

        // 初始状态检查
        setIsTabActive(!document.hidden);
        setIsWindowVisible(!document.hidden && document.hasFocus());

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
            document.removeEventListener('mouseenter', handleMouseEnter);
            document.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [isTabActive]);

    return {
        isWindowVisible,
        isTabActive,
    };
}; 